module.exports = __webpack_public_path__ + "static/usatsylacauga-8f9e74a31b3ca11f0c07b1c5e55bbb32.jpg";